import { render, staticRenderFns } from "./PartnerDomainList.vue?vue&type=template&id=64e3b65a&scoped=true"
import script from "./PartnerDomainList.vue?vue&type=script&lang=js"
export * from "./PartnerDomainList.vue?vue&type=script&lang=js"
import style0 from "./PartnerDomainList.vue?vue&type=style&index=0&id=64e3b65a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e3b65a",
  null
  
)

export default component.exports